import { Fab } from "@mui/material";
import ModalBox from "components/modal/ModalBox";
import NotFound from "components/not-found/NotFound";
import useDebounce from "hooks/useDebounce";
import useFullPageLoader from "hooks/useFullPageLoader";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "components/Button/Button";
import TaskIcon from "@mui/icons-material/Task";
import ReactSelect from "react-select";

import {
  deleteLecture,
  downloadBalanceReport,
  downloadStudentReport,
  getBalancePayment,
} from "services/lecture/lectureController";
import { dataIsAvailable } from "utils";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import SpeedDial from "components/speed-dial/SpeedDial";
import useDataTable from "hooks/useDataTable";
import { Table } from "react-bootstrap";
import IconButton from "components/Button/IconButton";
import Link from "components/Button/Link";
import { getSignedUrl } from "services/master";
import { dateFormat, balancepaymentdateFormat } from "utils";
import { getAffiliates } from "services/master/index";
import { getBillingCourses, getBillingCoursesForBalancePayment } from "services/course/subjectMappingController";

import * as XLSX from "xlsx";

function NewStudentAdmission() {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  const [selectedCourse, setSelectedCourse] = useState(null); // State to hold the selected course
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);
  const [selectedType, setselectedType] = useState("");
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [balanceTotal, setBalanceTotal] = useState(0);
  const [selectedAffiliate, setSelectedAffiliate] = useState(null);
  const [affiliateCourses, setAffiliateCourses] = useState([]);

  const [deleteModal, setDeleteModal] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [submitButtonElement1, setSubmitLoading1] = useMuiButtonLoader();

  const { TableHead, TableBody, selectedId, setSelectedId } = useDataTable(
    record,
    "LectureID"
  );

  const [search, setSearch] = useState("");
  const debounceValue = useDebounce(search || "", 300);

  const lectureListing = async (
    page = activePage,
    search = debounceValue,
    CourseID = selectedCourse ? selectedCourse.value : "",
    AffiliateID = selectedAffiliate ? selectedAffiliate.value : "",
    // FinancialYear = selectedFinancialYear?selectedFinancialYear.value:'',
  ) => {
    try {
      showLoader();
      const res = await getBalancePayment({
        page,
        search,
        CourseID,
        AffiliateID,
      });
      hideLoader();
      if (res.code === 200) {
        const { rows, count ,totalBalancePayment} = res.data.balancepaymentlist;
        setRecord(rows || []);
        setTotal(count || 0);
        setBalanceTotal(totalBalancePayment || 0);
        setSelectedId([]);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  //********Reset Filter****** */
  const restFilter = () => {
    setSearch("");
  };

  //   useEffect(() => {
  //     if (debounceValue) {
  //       searchParam.set("query", debounceValue);
  //     } else {
  //       searchParam.delete("query");
  //     }
  //     if (activePage === 1) {
  //       searchParam.delete("page");
  //     }
  //     setSearchParam(searchParam);
  //     lectureListing(activePage, debounceValue);
  //     // eslint-disable-next-line
  //   }, [searchParam, debounceValue,activePage]);
  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    // lectureListing(activePage, debounceValue, selectedCourse, selectedFinancialYear, selectedType);
    lectureListing(
      activePage,
      debounceValue,
      selectedCourse ? selectedCourse.value : "",
      selectedFinancialYear
        ? selectedFinancialYear.value.replaceAll("-", "")
        : "",
      selectedType ? selectedType.value : ""
    );
  }, [searchParam, debounceValue, activePage]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
    // eslint-disable-next-line
  }, [search]);

  // Function to handle year change
  const handleFinancialYearChange = (selectedOption) => {
    setSelectedFinancialYear(selectedOption);
  };

  // Function to handle center change
  const handleAdTypeChange = (selectedOption) => {
    setselectedType(selectedOption);
  };

  // Generate options for year dropdown (current year and previous three years)
  const currentYear = new Date().getFullYear();
  const financialYearOptions = Array.from({ length: 5 }, (_, index) => {
    const startYear = currentYear - index;
    const endYear = startYear + 1;
    const financialYearLabel = `${startYear}-${String(endYear).slice(2)}`;
    return { value: financialYearLabel, label: financialYearLabel };
  });

  // Options for center dropdown
  const AdmissionType = [
    { value: "Online", label: "Online" },
    { value: "Offline", label: "Offline" },
    { value: "Both", label: "Both" },
  ];

  const handleInvoiceDownload = async (fileurl) => {
    if (fileurl) {
      try {
        const signedUrl = await getSignedUrl({ pdfUrl: fileurl });
        window.open(signedUrl);
      } catch (error) {
        console.error("Error fetching signed URL:", error);
      }
    } else {
      console.error("error");
    }
  };

  const [allCourses, setAllCourses] = useState([]);

  const getAllCourses = async () => {
    showLoader();
    try {
      const res = await getBillingCoursesForBalancePayment();

      if (res.code === 200) {
        setAllCourses(res.data.courses || []);
        console.log("allCourses", allCourses);
        hideLoader();
      } else {
        console.log("error", res.message);
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    getAllCourses();
  }, []);

  const getAffiliateCourses = async () => {
    showLoader();
    try {
      const res = await getAffiliates();

      if (res.code === 200) {
        setAffiliateCourses(res.data.affiliates || []);
        console.log("affiliateCourses", affiliateCourses);
        hideLoader();
      } else {
        console.log("error", res.message);
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    getAffiliateCourses();
  }, []);

  const handleCourseChange = (selectedOption) => {
    setSelectedCourse(selectedOption);
  };

  const handleAffiliateChange = (selectedOption) => {
    setSelectedAffiliate(selectedOption);
  };


  const handleSearch = (e) => {
    e.preventDefault();
    lectureListing();
  };

  const downloadHandler = async () => {
    try {
      setSubmitLoading1(true);
      const finalData = {
        CourseID: selectedCourse ? selectedCourse.value : "",
        AffiliateID: selectedAffiliate ? selectedAffiliate.value : "",
      };

      const res = await downloadBalanceReport(finalData);

      // Assuming res.data is the data returned from the API
      const data = res.data.balancepaymentlist.rows.map((admission, index) => {
        let invoiceNo = "";
        const currentYear = new Date().getFullYear();

        if (admission.AdmissionType === "Online") {
          invoiceNo = `W-DL-${admission.FinancialYear}-${admission.InvoiceNo || ""}`;
        } else if (
          admission.AdmissionType === "Offline" &&
          admission.PaymentType === "Bank"
        ) {
          invoiceNo = `B-DL-${admission.FinancialYear}-${admission.InvoiceNo || ""}`;
        } else if (admission.AdmissionType === "Offline") {
          invoiceNo = `P-DL-${admission.FinancialYear}-${admission.InvoiceNo || ""}`;
        }

        return {
          "S.No": index + 1,
          "Payment Date": balancepaymentdateFormat(admission.BalancePayDate),
          "Balance Payment": admission.BalancePayment,
          "Course Fees": admission.CourseFees,
          "Course Name": admission.CourseName,
          "Student Name": admission.StudentName,
          "Email ID": admission.EmailID,
          "Mobile": admission.Mobile,
          "Admission Status": admission.AdmissionStatus,
          "Affiliate Name": admission.AffiliateName,
        };
      });

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Balance_Payment_Report.xlsx");
      setSubmitLoading1(false);
    } catch (err) {
      console.error("Error downloading Excel file:", err);
      setSubmitLoading1(false);
    }
  };


  return (
    <React.Fragment>
      <title>Shubhra Viraj | Student Admissions</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox"></div>
              <h4 className="Title">Balance Payment Report</h4>
            </div>
            <div className=" mt-3">
              {/* <form onSubmit={searchHandler}> */}
              <form>
                <div className="row w-100">
                  <div className={`col-form-label py-0 col-sm-4`}>
                    <ReactSelect
                      options={allCourses.map((course) => ({
                        value: course.CourseID,
                        label: course.CourseTitle,
                      }))}
                      value={selectedCourse}
                      onChange={handleCourseChange}
                      placeholder="Select a course"
                    />
                  </div>

                  <div className={`col-form-label py-0 col-sm-3`}>
                    <ReactSelect
                      options={affiliateCourses.map((affiliate) => ({
                        value: affiliate.AffiliateID,
                        label: affiliate.AffiliateName,
                      }))}
                      value={selectedAffiliate}
                      onChange={handleAffiliateChange}
                      placeholder="Select Affiliate"
                    />
                  </div>
                  <div className={`col-form-label py-0 col-sm-3`}>
                    <input
                      type="text"
                      placeholder="Enter Email/ Mobile"
                      className="form-control"
                      name="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>


                  <div className="col-sm-1 mx-4">
                    {/* <Button type="submit" {...submitButtonElement}>
                    Search
                  </Button> */}
                    <Button onClick={handleSearch} {...submitButtonElement}>
                      Search
                    </Button>
                  </div>
                </div>

              </form>
            </div>
            {loader}
            <hr className="border border-danger" />
          </div>

          <div className="Small-Wrapper my-3">
            <div className="search_wrap">
              <div className="SearchBox">
                <div className="div_wrap">
                  {/* <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    name="search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
        /> */}
                </div>
                <div className="div_no_wrap mx-1 row"></div>

                <div>
                  <Button onClick={downloadHandler} {...submitButtonElement1}>
                    Export To Excel
                  </Button>
                </div>
              </div>
              <h4 className="Title">
                Balance Payment (Total Records : {total}) (Total Balance Amount : <span style={{color:"darkred"}}>{balanceTotal}</span>)
              </h4>
            </div>
            {/* <h6 className="Title">Total ₹ {price}</h6> */}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Payment Date</th>
                    <th>Balance Amount</th>
                    <th>Course Fees</th>
                    <th>Course Name</th>
                    <th>Student Name</th>
                    <th>EmailID</th>
                    <th>Mobile</th>
                    <th>Admission Status</th>
                    <th>Affiliate Name</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map((data, i) => {
                      let invoiceNo = "";
                      const currentYear = new Date().getFullYear();

                      if (data.AdmissionType === "Online") {
                        invoiceNo = `W-DL-${data.FinancialYear}-${data.InvoiceNo || ""
                          }`;
                      } else if (
                        data.AdmissionType === "Offline" &&
                        data.PaymentType === "Bank"
                      ) {
                        invoiceNo = `B-DL-${data.FinancialYear}-${data.InvoiceNo || ""
                          }`;
                      } else if (data.AdmissionType === "Offline") {
                        invoiceNo = `P-DL-${data.FinancialYear}-${data.InvoiceNo || ""
                          }`;
                      }

                      // const displayPaymentType = data.AdmissionType === "Online" ? "Online" : data.PType;

                      return (
                        <tr key={i}>
                          <td>{++i + (activePage - 1) * 100}</td>
                          <td>{balancepaymentdateFormat(data.BalancePayDate)}</td>
                          <td>{data.BalancePayment}</td>
                          <td>{data.CourseFees}</td>
                          <td>{data.CourseName}</td>
                          <td>
                            {data.StudentName ? data.StudentName : `${data.StudentDetails?.FirstName} ${data.StudentDetails?.LastName}`}
                          </td>
                          <td>
                            {data.EmailID ? data.EmailID : `${data.StudentDetails?.EmailID}`}
                          </td>
                          <td>
                            {data.Mobile ? data.Mobile : `${data.StudentDetails?.Mobile}`}
                          </td>
                          <td>{data.AdmissionStatus}</td>
                          <td>{data.AffiliateName}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound cols={12} />
                  )}
                </tbody>
              </Table>
            </div>
            {total > 100 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={100}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default NewStudentAdmission;
